import Vue from "vue";
import Api from "@/utils/Api.js";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import defaultLayout from "./layouts/Default.vue";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import "./assets/sass/styles.sass";
import moment from "moment-timezone";

Vue.component("defaultLayout", defaultLayout);
Vue.config.productionTip = false;
Vue.prototype.Api = Api;
Vue.prototype.$moment = moment;
new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
